import { ActionRef } from '../../App/types/actionRef';
import { ScreenRef } from '../../App/types/screenRef';
import ExpEngine from '../../services/ExpEngine';
import { DisplayRuleStateMap } from '.';

export const getDisplayRulesState = (displayRules: DisplayRuleStateMap, screen: ScreenRef, action: ActionRef) => {
  const key = ExpEngine.getDisplayRuleService().getDisplayRuleKey(screen, action);
  const displayRule = displayRules[key];
  return displayRule ? displayRule.currentState || null : null;
};
